import { render, staticRenderFns } from "./IconOnlineCourse.vue?vue&type=template&id=e95ee940"
import script from "./IconOnlineCourse.vue?vue&type=script&lang=js"
export * from "./IconOnlineCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports